import { mkSiteBuilderComponent } from "@discovery/template-engine/lib/component-map";
export const NoOpMapItem = (props) => {
    return React.createElement("p", null, props.children);
};
export const ComponentMapItem = mkSiteBuilderComponent(() => { }, NoOpMapItem);

